import React, { Component } from "react";
import AntdCollapse, {CollapseProps} from "antd/lib/collapse";
import "antd/lib/collapse/style";

const { Panel } = AntdCollapse;
export default class Collapse extends Component<CollapseProps> {
  static Panel = Panel;
  render() {
    return <AntdCollapse {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/collapse/index.tsx